/* ==========================================================================
   Yumeka - theme behaviour
   Progressive enhancement only: every section renders and every link works
   with JS disabled. No scroll listeners anywhere (IntersectionObserver only).
   Motion durations and curves match assets/base.css.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Derniere variante annoncee par « variant:change », quelle qu en soit la
     source. Le selecteur du theme et le pont vers l application y ecrivent
     tous les deux, et le pont s en sert pour ne pas annoncer deux fois le
     meme changement. */
  var derniereVarianteAnnoncee = null;

  /* Shared money formatter, driven by the shop's own money_format.
     Every placeholder Shopify supports is handled: leaving one out means the
     raw "{{amount_with_comma_separator}}" ends up on screen. */
  function money(cents, fmtStr) {
    var f = fmtStr || '{{amount}}';

    function group(num, thousands, decimal, decimals) {
      var n = (cents / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimal) : parts[0];
    }

    var map = {
      amount: group(cents, ',', '.', 2),
      amount_no_decimals: group(cents, ',', '.', 0),
      amount_with_comma_separator: group(cents, '.', ',', 2),
      amount_no_decimals_with_comma_separator: group(cents, '.', ',', 0),
      amount_with_space_separator: group(cents, ' ', ',', 2),
      amount_no_decimals_with_space_separator: group(cents, ' ', ',', 0),
      amount_with_apostrophe_separator: group(cents, "'", '.', 2)
    };

    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : match;
    });
  }

  /* ---------- Scroll reveal ---------------------------------------------
     Purpose: sequence sections so one idea lands at a time. Not decoration. */
  function initReveal() {
    var items = $$('.reveal');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    items.forEach(function (el, i) {
      // Stagger only within a group, capped so nothing ever feels slow.
      var d = parseInt(el.getAttribute('data-reveal-delay') || '', 10);
      if (isNaN(d)) d = Math.min(i % 4, 3) * 70;
      el.style.setProperty('--reveal-delay', d + 'ms');
      io.observe(el);
    });
  }

  /* ---------- Header shadow on scroll (IO sentinel, no scroll handler) ---- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header || !('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;';
    document.body.prepend(sentinel);
    new IntersectionObserver(function (e) {
      header.classList.toggle('is-stuck', !e[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ---------- Mobile drawer ---------------------------------------------- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var panel  = $('.drawer__panel', drawer);
    var opener = $('[data-drawer-open]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var first = $('a, button', panel);
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    if (opener) opener.addEventListener('click', open);
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    // Focus trap
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', panel);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Product gallery -------------------------------------------- */
  /* ---------- Galerie : piste defilante ----------------------------------
     Le balayage au doigt est le geste attendu sur mobile ; il ne s'obtient pas
     en remplacant le src d'une image unique. Toutes les vues sont donc des
     diapositives dans une piste a defilement natif, et les vignettes ne font
     que viser un rang. Le JS ne fait que synchroniser : sans lui, la piste
     reste defilable et toutes les images restent atteignables. */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var track = $('[data-gallery-track]', g);
      if (!track) return;
      var slides = $$('[data-gallery-slide]', track);
      var thumbs = $$('[data-gallery-thumb]', g);
      if (!slides.length) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function paint(i) {
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      function goTo(i) {
        var el = slides[i];
        if (!el) return;
        track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        paint(i);
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-index'), 10) || 0);
        });
      });

      // La vignette active suit le doigt : sans cela elle mentirait des que la
      // cliente fait defiler elle-meme.
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = -1, dist = Infinity;
          slides.forEach(function (sl, k) {
            // Une diapositive masquee mesure 0 et se place a 0 : sans ce test
            // elle gagnerait la comparaison des que la piste est en debut de
            // course, et la vignette allumee designerait un visuel invisible.
            if (sl.hidden) return;
            var c = sl.offsetLeft - track.offsetLeft + sl.offsetWidth / 2;
            var d = Math.abs(c - mid);
            if (d < dist) { dist = d; best = k; }
          });
          if (best >= 0) paint(best);
          ticking = false;
        });
      }, { passive: true });

      // La page doit s'ouvrir sur la premiere image du PRODUIT, pas sur celle
      // du premier coloris.
      //
      // initVariants appelle update() au chargement, ce qui emet un
      // variant:change d'amorcage alors que personne n'a rien choisi. La
      // galerie le suivait et sautait aussitot sur l'image de la variante par
      // defaut : l'image de tete choisie dans l'administration n'etait jamais
      // celle que la cliente voyait en arrivant.
      //
      // Exception : une adresse qui porte deja ?variant=... designe une variante
      // precise -- un lien partage, un retour depuis le panier -- et celle qui
      // l'ouvre attend cette image-la.
      //
      // L'adresse est lue ICI, a l'initialisation, et le ?variant qu'on y
      // trouve ne peut venir que de l'exterieur : le theme n'en ecrit plus
      // (voir update(), plus bas). Le drapeau distingue donc bien un lien
      // partage d'une simple ouverture de page.
      var amorceAIgnorer = true;
      try {
        amorceAIgnorer = !new URLSearchParams(window.location.search).has('variant');
      } catch (err) { amorceAIgnorer = true; }

      /* ---- Galerie filtree par coloris --------------------------------
         Choisir un coloris ne fait plus seulement defiler jusqu'a son image :
         la galerie ne montre plus QUE les visuels de ce coloris, dans l'ordre
         des medias du produit.

         Le coloris d'un visuel est pose par le gabarit dans data-media-color,
         depuis le texte alternatif ou le nom du fichier. La table de
         correspondance rattrape les ecarts d'ecriture : la variante s'appelle
         « Bleu », les fichiers « bleu-ciel ».

         Regle de surete : si aucun visuel ne correspond au coloris choisi -- un
         coloris pas encore photographie -- on reaffiche tout. Une galerie vide
         serait pire que la galerie complete. */
      var carte = {}, filtrageActif = false, sauter = 0;
      try {
        var balise = $('[data-gallery-color-map]', g) || $('[data-gallery-color-map]');
        if (balise) {
          var cfg = JSON.parse(balise.textContent) || {};
          carte = cfg.correspondances || {};
          filtrageActif = cfg.actif === true;
          if (typeof cfg.sauter === 'number') sauter = cfg.sauter;
        }
      } catch (err) { carte = {}; filtrageActif = false; }

      // Espace et tiret sont interchangeables : la variante s'ecrit
      // « Vert sauge », le fichier « vert-sauge ». Sans cette normalisation ce
      // coloris ne trouvait aucun visuel et la galerie s'ouvrait en entier.
      var norm = function (v) {
        return String(v || '').toLowerCase().trim().replace(/\s+/g, '-');
      };
      var couleurDe = function (el) { return norm(el.getAttribute('data-media-color')); };
      var aDesCouleurs = slides.some(function (s) { return couleurDe(s); });

      function montrer(el, oui) {
        el.hidden = !oui;
        el.classList.toggle('is-masque', !oui);
      }

      function filtrer(variante) {
        if (!filtrageActif || !aDesCouleurs || !variante || !variante.options) return null;
        // On essaie chaque valeur d'option : seule celle du coloris trouvera
        // des visuels. Inutile de savoir laquelle porte la couleur.
        var vises = variante.options.map(function (v) {
          var k = norm(v);
          return norm(carte[k] || k);
        });
        var correspond = function (el) { return vises.indexOf(couleurDe(el)) !== -1; };
        var retenus = slides.filter(correspond);

        // Visuels communs : ceux qui ne portent aucun coloris. Les tout premiers
        // montrent le produit dans une teinte precise et n'ont donc rien a faire
        // sous un autre coloris -- on les saute. Le reste, ambiance, details et
        // schemas, vaut pour tous et reste affiche derriere les visuels du
        // coloris choisi.
        var communs = slides.filter(function (s) { return !couleurDe(s); });
        var gardes = communs.slice(sauter);

        if (!retenus.length) {                       // coloris sans visuel
          slides.forEach(function (s, i) {
            montrer(s, true); s.style.order = '';
            if (thumbs[i]) { montrer(thumbs[i], true); thumbs[i].style.order = ''; }
          });
          return null;
        }

        slides.forEach(function (s, i) {
          var duColoris = correspond(s);
          var visible = duColoris || gardes.indexOf(s) !== -1;
          // `order` plutot qu'un deplacement dans le DOM : la piste est une
          // grille, l'ordre visuel suffit. Deplacer les noeuds desynchroniserait
          // les vignettes, qui sont appariees aux diapositives par leur rang.
          s.style.order = duColoris ? '0' : '1';
          montrer(s, visible);
          if (thumbs[i]) { thumbs[i].style.order = s.style.order; montrer(thumbs[i], visible); }
        });
        return retenus[0];
      }

      // Changement de coloris : on amene la vue de la variante en tete plutot
      // que d'echanger un src. L'identifiant du media est porte par la
      // diapositive, donc la correspondance est exacte.
      document.addEventListener('variant:change', function (e) {
        // Le filtrage s'applique des le chargement : la fiche doit s'ouvrir sur
        // les visuels du coloris preselectionne, pas sur les trente.
        var premier = filtrer(e.detail);

        if (amorceAIgnorer) {
          amorceAIgnorer = false;
          // A l'arrivee on reste sur la premiere image du groupe affiche, sans
          // defilement anime : personne n'a encore rien choisi.
          if (premier) { premier.scrollIntoView({ block: 'nearest', inline: 'start' }); peindreVisible(); }
          return;
        }

        var mid = e.detail && e.detail.featured_media_id;
        if (mid) {
          for (var k = 0; k < slides.length; k++) {
            if (String(slides[k].getAttribute('data-media-id')) === String(mid) && !slides[k].hidden) {
              goTo(k); return;
            }
          }
        }
        // Pas d'image de tete utilisable : on ouvre sur le premier visuel du
        // coloris, ce qui reste le comportement attendu apres un changement.
        if (premier) goTo(slides.indexOf(premier));
      });

      // La vignette active doit suivre le filtrage, sinon elle reste allumee
      // sur un visuel devenu invisible.
      function peindreVisible() {
        var i = slides.findIndex(function (s) { return !s.hidden; });
        if (i >= 0) paint(i);
      }

      paint(0);
    });
  }

  /* ---------- Quantity ---------------------------------------------------- */
  function initQty() {
    $$('.qty[data-qty]').forEach(function (w) {
      var input = $('input', w);
      $$('button', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Variant picker ---------------------------------------------
     Reads the JSON variant map printed by the section, swaps price, media,
     availability and the hidden variant id. Falls back to a native <select>. */
  function initVariants() {
    $$('[data-variants]').forEach(function (root) {
      var dataEl = $('[data-variant-json]', root);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var idInput  = $('[data-variant-id]', root);
      var priceEl  = $('[data-variant-price]', root);
      var compareEl= $('[data-variant-compare]', root);
      var addBtn   = $('[data-add]', root);
      var fmtStr   = root.getAttribute('data-money-format') || '{{amount}}';

      function fmt(cents) { return money(cents, fmtStr); }
      function selected() {
        return $$('[data-opt-group]', root).map(function (g) {
          var on = $('[aria-pressed="true"]', g);
          return on ? on.getAttribute('data-value') : null;
        });
      }
      function update() {
        var chosen = selected();
        var match = variants.filter(function (v) {
          return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];

        // Grey out combinations that do not exist
        $$('[data-opt-group]', root).forEach(function (g, gi) {
          $$('[data-value]', g).forEach(function (chip) {
            var probe = chosen.slice();
            probe[gi] = chip.getAttribute('data-value');
            var ok = variants.some(function (v) {
              return probe.every(function (val, i) { return val === null || v.options[i] === val; }) && v.available;
            });
            chip.setAttribute('data-unavailable', ok ? 'false' : 'true');
          });
        });

        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = fmt(match.price);
        if (compareEl) {
          var show = match.compare_at_price && match.compare_at_price > match.price;
          compareEl.textContent = show ? fmt(match.compare_at_price) : '';
          compareEl.hidden = !show;
        }
        // The sticky bar sits outside [data-variants], so it has to be
        // updated explicitly or it keeps advertising a sold-out variant.
        [addBtn, $('[data-buybar-add]')].forEach(function (b) {
          if (!b) return;
          b.disabled = !match.available;
          b.textContent = match.available
            ? b.getAttribute('data-label-add')
            : b.getAttribute('data-label-sold');
        });
        var barPrice = $('[data-buybar-price]');
        // Overwritten straight after by the bundle selector when one exists.
        if (barPrice) barPrice.textContent = fmt(match.price);
        // L'echange de src est supprime : la galerie est desormais une piste de
        // diapositives, et remplacer la source de la premiere corromprait la vue
        // qui lui appartient. C'est initGallery qui amene la bonne diapositive
        // en vue, sur l'evenement variant:change.
        // L'adresse n'est plus reecrite. update() etant appele des
        // l'initialisation, un ?variant= s'ajoutait tout seul avant tout choix
        // de la cliente : toute adresse copiee depuis la barre figeait le
        // premier coloris, y compris dans une publicite ou un partage.
        //
        // Retirer l'ecriture ne casse pas la lecture d'un lien partage : c'est
        // initGallery (ligne ~197) qui interroge l'adresse, et boot() l'appelle
        // AVANT initVariants. Il lit donc l'adresse entrante, celle que Shopify
        // a servie, exactement comme avant. Un lien ...?variant=123 continue
        // d'ouvrir la bonne image ; seule l'ecriture automatique disparait.
        //
        // Contrepartie assumee : un coloris choisi puis un rechargement de page
        // repart sur la variante par defaut, l'adresse n'en gardant plus trace.
        // Let the bundle selector reprice against the newly chosen variant.
        derniereVarianteAnnoncee = String(match.id);
        root.dispatchEvent(new CustomEvent('variant:change', { detail: match, bubbles: true }));
      }

      $$('[data-opt-group]', root).forEach(function (g) {
        $$('[data-value]', g).forEach(function (chip) {
          chip.addEventListener('click', function () {
            $$('[data-value]', g).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
            chip.setAttribute('aria-pressed', 'true');
            // Le libelle du groupe suit la valeur choisie. Sans cela, une
            // pastille de couleur cochee laissait « Couleur : Gris » affiche
            // alors que le bleu etait selectionne : le seul endroit qui nomme
            // le coloris restait faux.
            var label = $('[data-opt-current]', g);
            var picked = chip.getAttribute('data-value');
            if (label && picked) label.textContent = picked;
            update();
          });
        });
      });
      update();
    });
  }

  /* ---------- Bundle selector --------------------------------------------
     The chosen tier drives three things: the quantity posted to the cart,
     the discount code the cart is routed through, and every price on screen.
     Repricing on variant change keeps the tiers honest when a pricier
     colour or size is picked. */
  function initBundle() {
    var root = $('[data-bundle]');
    if (!root) return;
    var scope = root.closest('[data-variants]') || document;
    var fmtStr = (scope.getAttribute && scope.getAttribute('data-money-format')) || '{{amount}} EUR';
    var barPrice = $('[data-buybar-price]');
    var current = null;

    function seed() {
      var el = $('[data-variant-json]', scope);
      if (!el) return null;
      try {
        var list = JSON.parse(el.textContent);
        var idEl = $('[data-variant-id]', scope);
        var picked = idEl && list.filter(function (v) { return String(v.id) === String(idEl.value); })[0];
        return picked || list[0];
      } catch (e) { return null; }
    }

    function reprice(variant) {
      if (!variant) return;
      current = variant;
      $$('.bcard', root).forEach(function (opt) {
        var input = $('input', opt);
        var q = parseInt(input.getAttribute('data-qty'), 10) || 1;
        // Meme calcul que le gabarit Liquid, et il doit le rester : sans cela
        // le premier changement de coloris remettrait l'ancien barre.
        // Reference = prix compare quand il existe, prix courant sinon.
        var unitRef = (variant.compare_at_price > variant.price)
          ? variant.compare_at_price
          : variant.price;
        var gross = unitRef * q;
        // Ce que la cliente paie sans prix de lot saisi : le prix pratique,
        // jamais la reference barree.
        var paye = variant.price * q;
        // A tier price set in the editor is what the customer is charged, so
        // it stays fixed; only the struck-through reference follows the variant.
        // Unites payees d'abord, exactement comme le gabarit.
        //
        // Le script ne lisait que data-price, l'ancien montant ecrit en dur.
        // Depuis que les offres se declarent en « N achetes, M offerts », ce
        // champ est vide : le script retombait sur prix x quantite et ECRASAIT
        // le bon prix rendu par le serveur. La page affichait 79,90 puis
        // 159,80 des que le script s'executait.
        //
        // Le calcul suit la variante choisie, donc changer de coloris garde le
        // prix juste sans recharger.
        var paidUnits = parseInt(input.getAttribute('data-paid-units'), 10) || 0;
        var fixed = parseInt(input.getAttribute('data-price'), 10);
        var net;
        if (paidUnits > 0) net = variant.price * paidUnits;
        else net = fixed > 0 ? fixed : paye;
        var save = Math.max(gross - net, 0);

        var now = $('[data-bundle-price]', opt);
        var refEl = $('[data-bundle-ref]', opt);
        var saveEl = $('[data-bundle-save]', opt);
        var eachEl = $('[data-bundle-each]', opt);
        if (now) now.textContent = money(net, fmtStr);
        if (refEl) { refEl.textContent = money(gross, fmtStr); refEl.hidden = gross <= net; }
        if (saveEl) {
          saveEl.textContent = money(save, fmtStr);
          var saveWrap = saveEl.closest('.bcard__save');
          if (saveWrap) saveWrap.hidden = save <= 0;
        }
        if (eachEl) eachEl.textContent = money(Math.round(net / q), fmtStr);
      });
      apply();
    }

    function apply() {
      var checked = $('input[name="quantity"]:checked', root);
      if (!checked) return;
      // Le radio coché porte name="quantity" : il n'y a plus de champ caché à
      // recopier, donc plus d'écart possible entre la carte affichée et ce qui
      // part réellement au panier.
      // Tier discounts are automatic in the admin, so the cart needs no code.
      //
      // La destination n'est plus reecrite ici. Elle vient du reglage « Aller
      // directement au paiement », que le gabarit inscrit dans le champ
      // return_to. Ecraser cette valeur a chaque changement de lot annulait le
      // reglage des que la cliente touchait une carte : le raccourci vers la
      // caisse ne tenait que tant qu'on ne choisissait rien.
      var opt = checked.closest('.bcard');
      var now = opt && $('[data-bundle-price]', opt);
      if (barPrice && now) barPrice.textContent = now.textContent;
      if (now) pay4x.maj(now.textContent);
      else if (variant && variant.price) pay4x.maj(variant.price);
    }

    $$('input[name="quantity"]', root).forEach(function (i) { i.addEventListener('change', apply); });
    document.addEventListener('variant:change', function (e) { reprice(e.detail); });
    reprice(seed());
  }

  /* ---------- Sticky buy bar --------------------------------------------- */
  function initBuyBar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-buybar-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var hasSeenAnchor = false;
    new IntersectionObserver(function (e) {
      var entry = e[0];
      if (entry.isIntersecting) hasSeenAnchor = true;
      bar.classList.toggle('is-in', hasSeenAnchor && !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Paiement en 4 fois ----------------------------------------
     Le montant affiche doit suivre l offre reellement choisie : BundleX et le
     selecteur de lot changent le prix sans recharger la page. Une mensualite
     restee sur l ancien prix serait un chiffre faux sous le bouton d achat.

     La ligne se masque hors des bornes posees dans le snippet : un panier qui
     n a pas droit au paiement en plusieurs fois ne doit pas le voir annonce. */
  var pay4x = (function () {
    var ligne = null, mini = 0, maxi = 0;

    function enCentimes(valeur) {
      if (typeof valeur === 'number') return Math.round(valeur);
      if (!valeur) return 0;
      var brut = String(valeur).replace(/[^0-9.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
      var nombre = parseFloat(brut);
      return isNaN(nombre) ? 0 : Math.round(nombre * 100);
    }

    function enEuros(centimes) {
      return (centimes / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC';
    }

    return {
      init: function () {
        ligne = $('[data-pay4x]');
        if (!ligne) return;
        mini = parseInt(ligne.getAttribute('data-min'), 10) || 0;
        maxi = parseInt(ligne.getAttribute('data-max'), 10) || 0;
        if (ligne.hasAttribute('data-pay4x-panier')) {
          ligne.addEventListener('click', function () {
            /* Le chemin normal, pas de raccourci : c est lui qui laisse
               l application ajouter l offre et le cadeau. On force seulement
               la destination sur le panier, ou PayPal emporte tout. */
            var form = ligne.closest('[data-cart-form]') || $('[data-cart-form]');
            if (!form) return;
            var dest = $('[data-return-to]', form);
            if (dest) dest.value = '/cart';
            var cta = $('[data-add]', form);
            if (cta) cta.click();
          });
        }
      },
      maj: function (valeur) {
        if (!ligne) return;
        var total = enCentimes(valeur);
        if (!total) return;
        var admis = total >= mini && total <= maxi;
        ligne.hidden = !admis;
        if (!admis) return;
        var montant = $('[data-pay4x-montant]', ligne);
        if (montant) montant.textContent = enEuros(Math.round(total / 4));
      }
    };
  })();

  /* ---------- Offres oreillers pilotées par Bundlex ----------------------
     L'application reste seule responsable des quantités, variantes et prix. */
  function initNuageCta() {
    var button = $('[data-adaptive-pillow-cta]');
    if (!button || !window.MutationObserver) return;
    var form = button.closest('[data-cart-form]');
    if (!form) return;
    var isAlign = button.hasAttribute('data-align-offer');
    var widget = null;

    function prepareAlignOffers(selectInitial) {
      if (!isAlign || !widget) return;
      var bogo = null;
      $$('.js-bx-offer', widget).forEach(function (offer) {
        var title = $('.bx-offer-title', offer);
        var text = title ? title.textContent.toLowerCase() : '';
        if (text.indexOf('2 achetés') !== -1) {
          if (!offer.hidden) offer.hidden = true;
          if (offer.getAttribute('aria-hidden') !== 'true') offer.setAttribute('aria-hidden', 'true');
          if (offer.getAttribute('aria-disabled') !== 'true') offer.setAttribute('aria-disabled', 'true');
          if (offer.getAttribute('tabindex') !== '-1') offer.setAttribute('tabindex', '-1');
          return;
        }
        if (text.indexOf('1 acheté') !== -1) {
          bogo = offer;
          var badge = $('.bx-offer-badge', offer);
          if (badge && badge.textContent.trim() !== 'OFFRE DE LANCEMENT') {
            badge.textContent = 'OFFRE DE LANCEMENT';
          }
        }
      });
      if (selectInitial && bogo && bogo.getAttribute('aria-checked') !== 'true') bogo.click();
    }

    function sync() {
      var active = widget && widget.querySelector('.js-bx-offer[aria-checked="true"], .js-bx-offer.bx-active');
      var price = active && active.querySelector('.bx-discounted-price');
      var priceText = price ? price.textContent.trim() : '';
      if (priceText) pay4x.maj(priceText);
    }

    function arm() {
      widget = document.querySelector('.bx-widget');
      if (!widget) return false;
      prepareAlignOffers(true);
      new MutationObserver(function () {
        prepareAlignOffers(false);
        sync();
      }).observe(widget, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-checked', 'class']
      });
      widget.addEventListener('click', function () { window.requestAnimationFrame(sync); });
      widget.addEventListener('change', sync);
      sync();
      return true;
    }

    if (arm()) return;
    var loader = new MutationObserver(function () {
      if (!arm()) return;
      loader.disconnect();
    });
    loader.observe(document.body, { subtree: true, childList: true });
  }

  /* ---------- Add to cart (AJAX with a real error state) ------------------
     Le formulaire ne poste qu'un id et une quantité : c'est ce contrat qui fait
     fonctionner le paiement express et l'envoi sans JavaScript. Ici on lit ce
     qui est réellement affiché à l'écran — une variante par unité du lot — on
     l'agrège, et on envoie UN seul appel à /cart/add.js avec un tableau items
     en JSON. C'est ce format-là qui est documenté ; le tableau items[n][…] en
     formulaire encodé renvoie 400 dès qu'un indice se retrouve orphelin.

     Une seule requête, donc : panier cohérent ou rien. Deux appels laisseraient
     un panier à moitié rempli quand le second échoue. */

  function variantJson(root, selector) {
    var el = root && root.querySelector ? root.querySelector(selector) : null;
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Recoupe une variante à partir des valeurs choisies, indexées par la
     position de l'option dans variant.options. C'est l'indice et non le nom qui
     sert de clé : un nom d'option se renomme dans l'administration, sa position
     est ce que Shopify utilise réellement. */
  function matchVariant(list, chosen) {
    if (!list) return null;
    for (var i = 0; i < list.length; i++) {
      var v = list[i], ok = true;
      for (var j = 0; j < v.options.length; j++) {
        if (chosen[j] != null && v.options[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Lit un groupe de <select> et rend les valeurs rangées par indice d'option,
     et non dans l'ordre du DOM : les deux coïncident aujourd'hui, mais rien ne
     l'impose, et un tableau mal ordonné recouperait la mauvaise variante. */
  function chosenFrom(selects) {
    var chosen = [];
    selects.forEach(function (sel) {
      var i = parseInt(sel.getAttribute('data-option-index'), 10);
      if (!isNaN(i)) chosen[i] = sel.value;
    });
    return chosen;
  }

  /* Agrège par identifiant de variante en conservant l'ordre d'apparition.
     Trois unités dont deux partagent une variante font DEUX lignes — une de
     quantité 2, une de quantité 1 — et non trois lignes de quantité 1. */
  function addLine(items, seen, id, qty) {
    if (seen[id] === undefined) {
      seen[id] = items.length;
      items.push({ id: id, quantity: 0 });
    }
    items[seen[id]].quantity += qty;
  }

  function initAddToCart() {
    $$('[data-cart-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;             // let the browser POST normally
        e.preventDefault();
        // Two submit buttons drive this form: the one in the buy column and
        // the sticky bar, which lives outside the <form> element.
        var btns = [$('[data-add]', form), $('[data-buybar-add]')].filter(Boolean);
        var err = $('[data-cart-error]', form);
        function fail(msg) {
          if (err) { err.textContent = msg; err.hidden = false; }
          btns.forEach(function (b) { b.classList.remove('is-loading'); });
        }
        if (err) { err.textContent = ''; err.hidden = true; }
        btns.forEach(function (b) { b.classList.add('is-loading'); });

        var scope = form.closest('[data-variants]') || document;

        // Les lots sont des radios name="quantity" : sans le :checked on
        // renverrait toujours la quantité de la première carte.
        var lot = $('input[name="quantity"]:checked', form);
        var qtyEl = lot || $('[data-qty-field]', form) || $('[name="quantity"]', form);
        var qty = Number((qtyEl || {}).value || 1);
        var card = lot && lot.closest('[data-bcard]');

        var items = [];
        var seen = {};
        var rows = card ? $$('[data-unit]', card) : [];
        var variants = variantJson(scope, '[data-variant-json]');

        // Filet de sécurité. Le nombre de lignes et la quantité du radio
        // viennent de la même variable Liquid, ils ne peuvent pas diverger. S'ils
        // divergent quand même, la page n'est pas celle qu'on croit : on refuse,
        // plutôt que d'envoyer un lot incomplet qui raterait la réduction
        // automatique et facturerait le mauvais total.
        if (rows.length && rows.length !== qty) {
          fail('Le lot affiché ne correspond plus à sa quantité. Rechargez la page avant de commander.');
          return;
        }

        if (rows.length && variants) {
          for (var r = 0; r < rows.length; r++) {
            var m = matchVariant(variants, chosenFrom($$('[data-unit-select]', rows[r])));
            // Une ligne non résolue arrête tout. Envoyer les autres ferait
            // partir un lot amputé, facturé au prix du lot complet.
            if (!m) {
              fail('Une des combinaisons choisies n’existe pas. Vérifiez les listes déroulantes du lot.');
              return;
            }
            addLine(items, seen, m.id, 1);
          }
        }

        // Repli : réglage « variante par unité » décoché, produit sans variante,
        // aucun bloc de lot, ou JSON illisible. Le champ caché name="id" fait
        // foi, exactement comme sans JavaScript.
        if (!items.length) {
          items.push({ id: Number($('[data-variant-id]', form).value), quantity: qty });
        }

        // La taie part comme article supplémentaire du MÊME tableau, jamais par
        // un second appel. Sa quantité suit celle du lot : le bandeau de la carte
        // cochée porte la quantité proportionnelle.
        var addon = $('[data-addon]', form);
        if (addon && addon.checked) {
          var band = card && $('[data-addon-qty]', card);
          var aq = band ? parseInt(band.getAttribute('data-addon-qty'), 10) : 1;
          if (!(aq > 0)) aq = 1;

          // La variante vient de la carte cochee : chaque carte peut pointer
          // son propre produit d'appoint. La valeur de la case ne sert plus que
          // de repli, pour les cartes qui n'en designent aucun.
          var aVar = band && band.getAttribute('data-addon-variant');
          var aid = Number(aVar || addon.value);
          // Le catalogue de la carte prime sur celui de la section : deux
          // cartes peuvent pointer deux produits d'appoint differents, et
          // resoudre la combinaison dans le mauvais catalogue ajoutait l'autre
          // produit au panier.
          var aList = (card && variantJson(card, '[data-card-addon-json]'))
                   || variantJson(scope, '[data-addon-json]');
          var aSel = card ? $$('[data-addon-select]', card) : [];
          if (aList && aSel.length) {
            var am = matchVariant(aList, chosenFrom(aSel));
            if (!am) {
              fail('La combinaison choisie pour l’option n’existe pas. Vérifiez ses listes déroulantes.');
              return;
            }
            aid = am.id;
          }
          addLine(items, seen, aid, aq);
        }

        // Volontairement aucun contrôle de disponibilité ici : le JSON date du
        // chargement de la page. Un article réapprovisionné depuis serait refusé
        // à tort. C'est au serveur de trancher, il a le stock réel.

        var routeEl = $('[data-return-to]', form);
        var route = routeEl && routeEl.value ? routeEl.value : '/cart';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Ajout impossible.');
            // On redirige des que l'ajout est confirme, sans rien attendre
            // d'autre.
            //
            // Un second appel a /cart.js precedait cette ligne, uniquement pour
            // rafraichir le compteur de l'icone panier. Sur une page qui est
            // detruite dans la milliseconde qui suit, c'etait de l'attente pure :
            // mesure sur la boutique, 584 ms pour l'ajout puis 123 ms de plus
            // avant que la redirection ne parte, depuis une connexion filaire.
            // En 4G ce second aller-retour coute le triple.
            //
            // Le compteur n'y perd rien : header.liquid ecrit cart.item_count
            // cote serveur, la page d'arrivee l'affiche donc deja juste.
            /* Une offre peut s intercaler ici, et elle seule decide.

               Le contrat est etroit expres : proposer() rend true UNIQUEMENT
               si elle prend en charge la redirection. Au moindre doute --
               produit non concerne, offre deja refusee, panier illisible --
               elle rend false et la redirection part normalement. Une offre
               ratee coute une vente en plus ; une redirection ratee coute la
               vente tout court. */
            if (window.YKUpsell && window.YKUpsell.proposer(items, route)) return;
            window.location.href = route;
          })
          .catch(function (e2) {
            if (err) { err.textContent = e2.message; err.hidden = false; }
          })
          .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
      });
    });
  }

  /* ---------- Disponibilité des lignes d'unité ----------------------------
     Une <option disabled> n'est atteignable ni au clavier ni au lecteur
     d'écran : la cliente qui navigue au clavier ne saurait jamais pourquoi un
     coloris manque. Le suffixe « épuisé » n'est qu'un repère visuel, il ne
     remplace pas une annonce.

     Et le disabled ne couvre de toute façon pas le cas le plus vicieux : une
     valeur disponible en soi, dont la COMBINAISON avec l'autre option ne l'est
     pas. Bleu existe, 65 x 65 existe, Bleu en 65 x 65 non — aucun des deux
     <select> ne peut le dire seul.

     Ce contrôle vit ici, dans theme.js, et non dans yumeko.js : c'est de la
     logique de variante, et matchVariant / chosenFrom sont déjà là. Les
     recopier dans l'autre fichier serait la troisième duplication de ce thème. */
  function initUnitAvailability() {
    $$('[data-variants]').forEach(function (root) {
      var list  = variantJson(root, '[data-variant-json]');
      var aList = variantJson(root, '[data-addon-json]');
      if (!list) return;

      function report(group, selects, source) {
        var msg = $('[data-unit-msg]', group);
        if (!msg) return;
        if (!selects.length || !source) { msg.textContent = ''; msg.hidden = true; return; }
        var chosen = chosenFrom(selects);
        var m = matchVariant(source, chosen);
        var tpl = '';
        if (!m) tpl = msg.getAttribute('data-none') || '';
        else if (!m.available) tpl = msg.getAttribute('data-out') || '';
        // Le libellé reprend les valeurs dans l'ordre des options du produit,
        // pas dans celui du DOM : « Bleu / 65 x 65 » et jamais l'inverse.
        msg.textContent = tpl.replace('{combo}', chosen.filter(Boolean).join(' / '));
        msg.hidden = tpl === '';
      }

      function sync() {
        $$('[data-unit]', root).forEach(function (row) {
          report(row, $$('[data-unit-select]', row), list);
        });
        $$('[data-addon-group]', root).forEach(function (grp) {
          // Le catalogue de la CARTE d'abord, celui de la section seulement en
          // repli. Chaque carte de lot peut viser son propre produit d'option :
          // la fiche Oreiller Nuage propose « 2 taies - option oreiller » sur
          // une carte alors que le reglage de section pointe « 4 taies ». En
          // lisant toujours la liste de section, le controle comparait le
          // coloris choisi au catalogue d'un autre produit, n'y trouvait rien,
          // et annoncait « Cette combinaison n'existe pas » sur une combinaison
          // parfaitement valide -- « Marine » existe, mais dans l'autre liste.
          //
          // Le panier, lui, n'a jamais ete trompe : il poste data-addon-variant,
          // qui vient bien du produit de la carte. Le defaut etait dans le seul
          // controle d'affichage, et il decourageait l'option juste avant l'achat.
          var propre = variantJson(grp, '[data-card-addon-json]');
          report(grp, $$('[data-addon-select]', grp), propre || aList);
        });
      }

      // 'change' couvre les modifications faites à la main ; 'units:change' est
      // émis par le réalignement, qui écrit les valeurs sans qu'aucun 'change'
      // ne parte de lui-même.
      root.addEventListener('change', sync);
      document.addEventListener('units:change', sync);
      sync();
    });
  }
  /* ---------- Accordion height animation ---------------------------------- */
  function initFaq() {
    $$('.qa').forEach(function (d) {
      var q = $('.qa__q', d);
      if (!q) return;
      q.addEventListener('click', function () {
        // Close siblings so only one answer is open at a time
        var parent = d.parentElement;
        $$('.qa[open]', parent).forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      });
    });
  }

  /* ---------- Copy discount code -----------------------------------------
     Motion purpose: feedback. The label confirms the copy actually landed. */
  function initCopy() {
    $$('[data-copy]').forEach(function (btn) {
      var hint = $('[data-copy-hint]', btn);
      var idle = hint ? hint.textContent : '';
      var timer;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy');
        var done = function () {
          if (!hint) return;
          hint.textContent = 'Copié';
          clearTimeout(timer);
          timer = setTimeout(function () { hint.textContent = idle; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () {});
        } else {
          var t = document.createElement('textarea');
          t.value = code; t.setAttribute('readonly', '');
          t.style.cssText = 'position:absolute;left:-9999px';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); done(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  }

  /* ---------- pont entre une application d’offres et la galerie -------- */

  /* Une application comme BundleX choisit la variante a la place du theme.

     Elle le fait bien : elle reecrit l attribut `value` du champ cache
     `name="id"` du formulaire d ajout -- verifie sur la fiche couette, un clic
     sur la pastille « Gris » fait passer 59113092972918 a 59113093038454.
     Mais elle n emet aucun evenement, et la galerie du theme, qui attend
     « variant:change », ne voit jamais rien. Le coloris changeait donc dans
     l offre sans que la photo bouge.

     Ce pont ne fait que traduire : il observe le champ, retrouve la variante
     dans le JSON rendu par Liquid, et annonce le changement comme le ferait
     le selecteur du theme. Toute la suite -- galerie, prix, disponibilite --
     est deja branchee sur cet evenement et n a rien a apprendre.

     Deux garde-fous. Le drapeau evite d annoncer deux fois le meme changement
     quand c est le selecteur du theme qui a agi. Et une variante absente du
     JSON n est pas annoncee : mieux vaut une galerie qui ne bouge pas qu une
     galerie qui montre autre chose que ce qui sera facture.

     Limite connue : l observation porte sur l ATTRIBUT `value`. Une
     application qui ecrirait la propriete sans toucher a l attribut passerait
     inapercue. BundleX ecrit l attribut, et c est ce qui a ete mesure. */
  function initPontVariante() {
    var root = $('[data-variants]');
    if (!root || !window.MutationObserver) return;

    var variants = variantJson(root, '[data-variant-json]');
    if (!variants.length) return;

    var lire = function () {
      var champ = $('input[name="id"]', root);
      return champ ? String(champ.value) : null;
    };

    if (derniereVarianteAnnoncee === null) derniereVarianteAnnoncee = lire();

    /* On observe la COLONNE D ACHAT, pas le champ.

       Observer le champ lui-meme ne tenait pas : l application reconstruit le
       formulaire apres le demarrage du theme, et l observateur se retrouvait
       accroche a un noeud detache -- il ne voyait plus rien. Constate sur la
       fiche couette : le champ passait bien de 59113092972918 a 59113093038454,
       et aucune annonce ne partait.

       La colonne, elle, survit. On surveille donc son sous-arbre, les
       remplacements de noeuds compris, et on relit le champ a chaque fois. */
    new MutationObserver(function () {
      var id = lire();
      if (!id || id === derniereVarianteAnnoncee) return;

      var match = variants.filter(function (v) { return String(v.id) === id; })[0];
      if (!match) return;

      derniereVarianteAnnoncee = id;
      root.dispatchEvent(new CustomEvent('variant:change', { detail: match, bubbles: true }));
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
  }

  function boot() {
    initReveal(); initHeader(); initDrawer(); initGallery();
    initQty(); initVariants(); initBundle(); initBuyBar(); initNuageCta();
    pay4x.init();
    document.addEventListener('variant:change', function (e) { if (e.detail && e.detail.price) pay4x.maj(e.detail.price); });
    initAddToCart(); initUnitAvailability(); initFaq(); initCopy();
    initPontVariante();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
